import { render, staticRenderFns } from "./dsHome.vue?vue&type=template&id=2e755403&scoped=true"
import script from "./dsHome.vue?vue&type=script&lang=js"
export * from "./dsHome.vue?vue&type=script&lang=js"
import style0 from "./dsHome.vue?vue&type=style&index=0&id=2e755403&prod&lang=less&scoped=true"
import style1 from "./dsHome.vue?vue&type=style&index=1&id=2e755403&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e755403",
  null
  
)

export default component.exports